import {
    Configuration,
    EndSessionRequest,
    RedirectRequest
} from '@azure/msal-browser';

export const msalConfig: Configuration = {
    auth: {
        clientId: import.meta.env.VITE_WEB_CLIENT_ID as string,
        authority: import.meta.env.VITE_WEB_AUTHORITY as string,
        redirectUri: '/'
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false
    }
};

export const loginRequest: RedirectRequest = {
    scopes: ['User.Read']
};

export const logoutRequest: EndSessionRequest = {};

export const appRoles = {
    User: 'User',
    Developer: 'Developer',
    Admin: 'Admin',
    FinanceController: 'FinanceController'
};
